import { transformPaymentOptions } from '../api/transformations/paymentOptions';

import {
    UPDATE_AVAILABLE_PAYMENT_METHODS,
    SET_RELOAD_AFTER_CHECKOUT,
    SET_CAN_RETRY_SUBMIT,
    SET_HAS_VIRTUAL_INCENTIVE_ERRORS,
} from './constants';

export const setReloadAfterCheckout = (data) => ({
    type: SET_RELOAD_AFTER_CHECKOUT,
    payload: data,
});

/**
 * Returns true if the user has chosen to use CREDIT payment method,
 * has select to "add a new card", then checked the save options checkbox.
 *
 * Note: payment.vaultId === CREDIT if the user chose to add a new card.
 */
export const setCanRetrySubmit = (canRetrySubmit) => ({
    type: SET_CAN_RETRY_SUBMIT,
    payload: canRetrySubmit,
});

export const _updateAvailablePaymentMethods = (data) => ({
    type: UPDATE_AVAILABLE_PAYMENT_METHODS,
    payload: transformPaymentOptions(data),
});

export const isIdentificationRequiredForCurrency = {
    BRL: true,
    ARS: true,
    MXN: true,
};

export const setHasVirtualIncentiveErrors = (hasErrors) => ({
    type: SET_HAS_VIRTUAL_INCENTIVE_ERRORS,
    payload: hasErrors,
});
